export function isKeyOf<Key extends string>(
  record: Partial<Record<Key, unknown>>,
  key: string,
): key is Key {
  return Object.prototype.hasOwnProperty.call(record, key);
}

export function recordKeys<Key extends string>(
  record: Record<Key, unknown>,
): Key[] {
  return Object.keys(record).filter((key): key is Key => isKeyOf(record, key));
}
